// import { Field } from "formik";
// import {
//   FC,
//   useState,
//   useRef,
//   useEffect,
//   ChangeEvent,
//   Fragment,
//   ReactElement,
// } from "react";
// import { StyleFormWrapper, StyleLabel, StylePlaceholder } from "../style";
// import {
//   StyleDropDownWrapper,
//   StyleDropDownOptionWrapper,
//   StyleDropDownOption,
//   StyleSelectedValue,
//   StyleDropDownSearchInput,
//   StyleDropDownSearchWrapper,
//   StyleDropDownOptionItems,
//   StyleDropDownIconWrapper,
//   StyleSelectedItems,
//   StyleSelectedItem,
//   OptionImage,
// } from "./style";
// import ErrorMessage from "../ErrorMessage";
// import debounce from "@utils/debounce";
// import { ChevronDown } from "lucide-react";
// import styled from "@emotion/styled";

// interface DropDownProps {
//   options: Array<any>;
//   onChange?: (value: any) => void;
//   onSearch?: (value: any) => void;
//   label?: string;
//   placeholder?: string;
//   valueAsKey: string;
//   titleAsKey: string;
//   name: string;
//   isMultiple?: boolean;
//   isServerside?: boolean;
//   hasSearch?: boolean;
//   styleWrapper?: string;
//   styleLabel?: string;
//   styleInput?: string;
//   styleOptionsWrapper?: string;
//   disabled?: boolean;
//   tc?: any;
//   rightComponent?: ReactElement;
//   selectable?: boolean;
//   size?: number;
//   removeOption?: boolean;
// }

// const DropDown: FC<DropDownProps> = ({
//   options,
//   label,
//   onChange,
//   onSearch,
//   placeholder,
//   valueAsKey,
//   titleAsKey,
//   isServerside = false,
//   hasSearch = false,
//   name,
//   styleInput = "",
//   styleLabel = "",
//   styleWrapper = "",
//   styleOptionsWrapper = "",
//   disabled,
//   tc,
//   isMultiple = false,
//   rightComponent,
//   selectable = false,
//   size,
//   removeOption = true,
// }) => {
//   const [isOpen, setIsOpen] = useState<boolean>(false);
//   const [search, setSearch] = useState<string>("");
//   const dropdownRef = useRef<HTMLDivElement>(null);

//   const handleChange = ({ form, value }) => {
//     setIsOpen(false);
//     if (onChange) onChange(value);
//     else form.setFieldValue(name, value);
//   };

//   const handleMultiple = ({ form, value, values }) => {
//     const currentValues = values || [];
//     const findIndex = currentValues.findIndex(
//       (selected: any) => selected == value
//     );
//     if (findIndex >= 0) {
//       const filterValues = currentValues.filter((item) => item != value);
//       onChange
//         ? onChange(filterValues)
//         : form.setFieldValue(name, filterValues);
//     } else {
//       const finalValues = [...currentValues, value];
//       onChange ? onChange(finalValues) : form.setFieldValue(name, finalValues);
//     }
//   };

//   const handleSelectAll = (form: any, allSelected: boolean, values: any[]) => {
//     if (allSelected) {
//       onChange ? onChange([]) : form.setFieldValue(name, []);
//     } else {
//       const allIds = options.map((opt) => opt[valueAsKey]);
//       onChange ? onChange(allIds) : form.setFieldValue(name, allIds);
//     }
//   };

//   const handleSearch = debounce((value: string) => {
//     if (!isServerside) setSearch(value);
//     onSearch && onSearch(value);
//   }, 600);

//   const onClickOutside = (event: MouseEvent) => {
//     if (
//       dropdownRef.current &&
//       !dropdownRef.current.contains(event.target as Node)
//     ) {
//       setIsOpen(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", onClickOutside);
//     return () => document.removeEventListener("mousedown", onClickOutside);
//   }, []);

//   return (
//     <Field name={name}>
//       {({ field, meta, form }) => {
//         const hasError = meta.touched && meta.error;

//         const allSelected =
//           Array.isArray(field.value) &&
//           field.value?.length === options?.length &&
//           options?.length > 0;

//         const selectedOption = options?.find(
//           (option: any) => option[valueAsKey] == field?.value
//         );

//         return (
//           <StyleFormWrapper styleWrapper={styleWrapper}>
//             {!!label && (
//               <StyleLabel hasError={hasError} styleLabel={styleLabel}>
//                 {label}
//               </StyleLabel>
//             )}

//             <StyleDropDownWrapper
//               hasError={hasError}
//               onClick={() => !disabled && setIsOpen(!isOpen)}
//               disabled={disabled}
//               styleInput={styleInput}
//             >
//               {!!placeholder &&
//               (!!isMultiple ? !field?.value?.length : !field?.value) ? (
//                 <StylePlaceholder>{placeholder}</StylePlaceholder>
//               ) : (
//                 <>
//                   {!!isMultiple ? (
//                     <StyleSelectedItems>
//                       {options
//                         ?.filter((option) =>
//                           field.value
//                             ?.map(String)
//                             ?.includes(String(option[valueAsKey]))
//                         )
//                         ?.map((item) => (
//                           <StyleSelectedItem key={item[valueAsKey]}>
//                             {item?.[titleAsKey]}
//                             {removeOption ? (
//                               <span
//                                 style={{
//                                   marginLeft: "4px",
//                                   cursor: "pointer",
//                                   fontWeight: "bold",
//                                 }}
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleMultiple({
//                                     form,
//                                     value: item[valueAsKey],
//                                     values: field.value,
//                                   });
//                                 }}
//                               >
//                                 ×
//                               </span>
//                             ) : null}
//                           </StyleSelectedItem>
//                         ))}
//                     </StyleSelectedItems>
//                   ) : (
//                     <StyleSelectedValue tc={tc}>
//                       {selectedOption?.image && (
//                         <OptionImage
//                           src={selectedOption.image}
//                           alt={selectedOption[titleAsKey]}
//                         />
//                       )}
//                       {selectedOption?.[titleAsKey]}
//                     </StyleSelectedValue>
//                   )}
//                 </>
//               )}
//               <StyleDropDownIconWrapper>
//                 {!!rightComponent && rightComponent}
//                 <ChevronDown />
//               </StyleDropDownIconWrapper>
//             </StyleDropDownWrapper>

//             {!!isOpen && (
//               <StyleDropDownOptionWrapper
//                 styleOptionsWrapper={styleOptionsWrapper}
//                 ref={dropdownRef}
//                 top={!!label ? 80 : 50}
//               >
//                 {!!hasSearch && (
//                   <StyleDropDownSearchWrapper>
//                     <StyleDropDownSearchInput
//                       type="text"
//                       placeholder="Search"
//                       onChange={(event: ChangeEvent<HTMLInputElement>) =>
//                         handleSearch(event.target.value)
//                       }
//                     />
//                   </StyleDropDownSearchWrapper>
//                 )}

//                 <StyleDropDownOptionItems
//                   onClick={(event: any) => {
//                     const value = (event.target as HTMLElement)
//                       .closest("[data-id]")
//                       ?.getAttribute("data-id");
//                     if (value) {
//                       if (isMultiple) {
//                         handleMultiple({ form, value, values: field?.value });
//                       } else {
//                         handleChange({ form, value });
//                       }
//                       setIsOpen(false);
//                     }
//                   }}
//                 >
//                   {isMultiple && selectable && options?.length > 0 && (
//                     <StyleDropDownOption
//                       isActive={allSelected}
//                       onClick={() =>
//                         handleSelectAll(form, allSelected, field.value)
//                       }
//                     >
//                       {allSelected ? "Unselect All" : "Select All"}
//                     </StyleDropDownOption>
//                   )}

//                   {options
//                     ?.filter((option) =>
//                       option[titleAsKey]
//                         ?.toLowerCase()
//                         ?.includes(search.toLowerCase())
//                     )
//                     .map((option) => (
//                       <Fragment key={option[valueAsKey]}>
//                         <StyleDropDownOption
//                           data-id={option[valueAsKey]}
//                           isActive={
//                             isMultiple
//                               ? field.value
//                                   ?.map(String)
//                                   ?.includes(String(option[valueAsKey]))
//                               : field.value == option[valueAsKey]
//                           }
//                         >
//                           {option.image && (
//                             <OptionImage
//                               size={size}
//                               src={option.image}
//                               alt={option[titleAsKey]}
//                             />
//                           )}
//                           {option[titleAsKey]}
//                         </StyleDropDownOption>
//                       </Fragment>
//                     ))}
//                 </StyleDropDownOptionItems>
//               </StyleDropDownOptionWrapper>
//             )}

//             {!!hasError && <ErrorMessage message={meta.error} />}
//           </StyleFormWrapper>
//         );
//       }}
//     </Field>
//   );
// };

// export default DropDown;

import { Field } from "formik";
import {
  FC,
  useState,
  useRef,
  useEffect,
  ChangeEvent,
  Fragment,
  ReactElement,
} from "react";
import { StyleFormWrapper, StyleLabel, StylePlaceholder } from "../style";
import {
  StyleDropDownWrapper,
  StyleDropDownOptionWrapper,
  StyleDropDownOption,
  StyleSelectedValue,
  StyleDropDownSearchInput,
  StyleDropDownSearchWrapper,
  StyleDropDownOptionItems,
  StyleDropDownIconWrapper,
  StyleSelectedItems,
  StyleSelectedItem,
  OptionImage,
  OptionPlaceholder,
} from "./style";
import ErrorMessage from "../ErrorMessage";
import debounce from "@utils/debounce";
import { ChevronDown } from "lucide-react";
import styled from "@emotion/styled";

interface DropDownProps {
  options: Array<any>;
  onChange?: (value: any) => void;
  onSearch?: (value: any) => void;
  label?: string;
  placeholder?: string;
  valueAsKey: string;
  titleAsKey: string;
  name: string;
  isMultiple?: boolean;
  isServerside?: boolean;
  hasSearch?: boolean;
  styleWrapper?: string;
  styleLabel?: string;
  styleInput?: string;
  styleOptionsWrapper?: string;
  disabled?: boolean;
  tc?: any;
  rightComponent?: ReactElement;
  selectable?: boolean;
  size?: number;
  removeOption?: boolean;
  // New props for color support
  colorAsKey?: string; // Key in option object for color code
  showColor?: boolean; // Whether to show color swatches
}

// Styled component for color swatch - circular shape
const ColorSwatch = styled.div<{ color: string; size?: number }>`
  width: ${(props) => props.size || 16}px;
  height: ${(props) => props.size || 16}px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  border: 1px solid #ddd;
  margin-right: 8px;
  flex-shrink: 0;
`;

// Container for option content to handle both image and color
const OptionContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DropDown: FC<DropDownProps> = ({
  options,
  label,
  onChange,
  onSearch,
  placeholder,
  valueAsKey,
  titleAsKey,
  isServerside = false,
  hasSearch = false,
  name,
  styleInput = "",
  styleLabel = "",
  styleWrapper = "",
  styleOptionsWrapper = "",
  disabled,
  tc,
  isMultiple = false,
  rightComponent,
  selectable = false,
  size,
  removeOption = true,
  // New props with defaults
  colorAsKey = "color", // default key for color code
  showColor = false, // default to not showing colors
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleChange = ({ form, value }) => {
    setIsOpen(false);
    if (onChange) onChange(value);
    else form.setFieldValue(name, value);
  };

  const handleMultiple = ({ form, value, values }) => {
    const currentValues = values || [];
    const findIndex = currentValues.findIndex(
      (selected: any) => selected == value,
    );
    if (findIndex >= 0) {
      const filterValues = currentValues.filter((item) => item != value);
      onChange
        ? onChange(filterValues)
        : form.setFieldValue(name, filterValues);
    } else {
      const finalValues = [...currentValues, value];
      onChange ? onChange(finalValues) : form.setFieldValue(name, finalValues);
    }
  };

  const handleSelectAll = (form: any, allSelected: boolean, values: any[]) => {
    if (allSelected) {
      onChange ? onChange([]) : form.setFieldValue(name, []);
    } else {
      const allIds = options.map((opt) => opt[valueAsKey]);
      onChange ? onChange(allIds) : form.setFieldValue(name, allIds);
    }
  };

  const handleSearch = debounce((value: string) => {
    if (!isServerside) setSearch(value);
    onSearch && onSearch(value);
  }, 600);

  const onClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  // Helper function to render option content (handles both image and color)
  const renderOptionContent = (option: any) => (
    <OptionContent>
      {/* Show color swatch if enabled and color exists */}
      {showColor && option[colorAsKey] && (
        <ColorSwatch color={option[colorAsKey]} size={16} />
      )}
      {/* Show image if exists, fallback to initials placeholder */}
      {option.image ? (
        <OptionImage size={size} src={option.image} alt={option[titleAsKey]} />
      ) : option.initials ? (
        <OptionPlaceholder size={size}>
          {option.initials}
        </OptionPlaceholder>
      ) : null}
      {option[titleAsKey]}
    </OptionContent>
  );

  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error;

        const allSelected =
          Array.isArray(field.value) &&
          field.value?.length === options?.length &&
          options?.length > 0;

        const selectedOption = options?.find(
          (option: any) => option[valueAsKey] == field?.value,
        );

        return (
          <StyleFormWrapper styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}

            <StyleDropDownWrapper
              hasError={hasError}
              onClick={() => !disabled && setIsOpen(!isOpen)}
              disabled={disabled}
              styleInput={styleInput}
            >
              {!!placeholder &&
              (!!isMultiple ? !field?.value?.length : !field?.value) ? (
                <StylePlaceholder>{placeholder}</StylePlaceholder>
              ) : (
                <>
                  {!!isMultiple ? (
                    <StyleSelectedItems>
                      {options
                        ?.filter((option) =>
                          field.value
                            ?.map(String)
                            ?.includes(String(option[valueAsKey])),
                        )
                        ?.map((item) => (
                          <StyleSelectedItem key={item[valueAsKey]}>
                            <OptionContent>
                              {/* Color swatch for multiple selected items */}
                              {showColor && item[colorAsKey] && (
                                <ColorSwatch
                                  color={item[colorAsKey]}
                                  size={14}
                                />
                              )}
                              {item?.[titleAsKey]}
                            </OptionContent>
                            {removeOption ? (
                              <span
                                style={{
                                  marginLeft: "4px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMultiple({
                                    form,
                                    value: item[valueAsKey],
                                    values: field.value,
                                  });
                                }}
                              >
                                ×
                              </span>
                            ) : null}
                          </StyleSelectedItem>
                        ))}
                    </StyleSelectedItems>
                  ) : (
                    <StyleSelectedValue tc={tc}>
                      {selectedOption && renderOptionContent(selectedOption)}
                    </StyleSelectedValue>
                  )}
                </>
              )}
              <StyleDropDownIconWrapper>
                {!!rightComponent && rightComponent}
                <ChevronDown />
              </StyleDropDownIconWrapper>
            </StyleDropDownWrapper>

            {!!isOpen && (
              <StyleDropDownOptionWrapper
                styleOptionsWrapper={styleOptionsWrapper}
                ref={dropdownRef}
                top={!!label ? 80 : 50}
              >
                {!!hasSearch && (
                  <StyleDropDownSearchWrapper>
                    <StyleDropDownSearchInput
                      type="text"
                      placeholder="Search"
                      onChange={(event: ChangeEvent<HTMLInputElement>) =>
                        handleSearch(event.target.value)
                      }
                    />
                  </StyleDropDownSearchWrapper>
                )}

                <StyleDropDownOptionItems
                  onClick={(event: any) => {
                    const value = (event.target as HTMLElement)
                      .closest("[data-id]")
                      ?.getAttribute("data-id");
                    if (value) {
                      if (isMultiple) {
                        handleMultiple({ form, value, values: field?.value });
                      } else {
                        handleChange({ form, value });
                      }
                      setIsOpen(false);
                    }
                  }}
                >
                  {isMultiple && selectable && options?.length > 0 && (
                    <StyleDropDownOption
                      isActive={allSelected}
                      onClick={() =>
                        handleSelectAll(form, allSelected, field.value)
                      }
                    >
                      {allSelected ? "Unselect All" : "Select All"}
                    </StyleDropDownOption>
                  )}

                  {options
                    ?.filter((option) =>
                      option[titleAsKey]
                        ?.toLowerCase()
                        ?.includes(search.toLowerCase()),
                    )
                    .map((option) => (
                      <Fragment key={option[valueAsKey]}>
                        <StyleDropDownOption
                          data-id={option[valueAsKey]}
                          isActive={
                            isMultiple
                              ? field.value
                                  ?.map(String)
                                  ?.includes(String(option[valueAsKey]))
                              : field.value == option[valueAsKey]
                          }
                        >
                          {renderOptionContent(option)}
                        </StyleDropDownOption>
                      </Fragment>
                    ))}
                </StyleDropDownOptionItems>
              </StyleDropDownOptionWrapper>
            )}

            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        );
      }}
    </Field>
  );
};

export default DropDown;
